import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Card } from 'primeng/card';
import { SafeHtmlPipe } from '../../../core/pipes/safe-html.pipe';
import { I18nService } from '../../../core/services/i18n.service';
import { RuntimeConfigService } from '../../../core/services/runtime-config.service';

@Component({
  selector: 'sps-support-info',
  imports: [
    Card,
    SafeHtmlPipe,
    RouterLink
  ],
  templateUrl: './sps-support-info.component.html'
})
export class SpsSupportInfoComponent {

  /**
   * styleClass either gradient-background-h-full for full height or gradient-background for no auto-size
   */
  // @Input() gradientStyleClass: string = 'gradient-background-h-full';
  @Input() gradientStyleClass: string = 'sps-background-h-full';
  @Input() showContactSPS: boolean = false;

  i18n = inject(I18nService);
  runtimeConfig = inject(RuntimeConfigService);
  public spsContactUrl: string = this.runtimeConfig.spsContactUrl;

  /**
   * Links to the API-Reference and the User Manual
   */
  apiUrl: string = this.runtimeConfig.apiReferenceLink;
  manualUrl: string = this.runtimeConfig.userManualLink;
  faqUrl: string = this.runtimeConfig.faqLink;


}
